import React, {FC, memo, useState} from "react";
import {GridAreaContentLayout} from "./GridAreaContentLayout";
import {Countdown} from "../countdown/Countdown";
import {useStateValue} from "../state-provider/StateProvider";
import {GridAreaContentLayoutTextField} from "./GridAreaContentLayoutTextField";
import {GridAreaContentLayoutCheckbox} from "./GridAreaContentLayoutCheckbox";
import {GridAreaContentLayoutButton} from "./GridAreaContentLayoutButton";
import {ws} from "../../events/ws";
import {setGridAreaContent, setLiveStreamSubscribed, setUserEmail} from "../app/App.action";
import {sendToWidget} from "../../utils/postMessages";
import {log} from "../../utils/log";
import {IoNotificationsOutline} from "react-icons/io5";
import './ReminderForm.css'
import {useEmail} from "../../hooks/useEmail";


const ReminderForm2Component: FC<{
}> =
({
 }) => {

  const [{
    liveStreamSubscribed,
    futureLiveStreamsSubscribed,
    translations,
    userEmail,
    liveStream,
  }, dispatch] = useStateValue()

  const isSubscribed = liveStreamSubscribed || futureLiveStreamsSubscribed
  const { email, setEmail, isValid: isEmailValid } = useEmail(userEmail ?? "")
  const [similarEvents, setSimilarEvents] = useState<boolean>(true)

  const submit = () => {
    const timezone = new Intl.DateTimeFormat().resolvedOptions().timeZone
    try {
      let pastScheduledTime = new Date(parseInt(liveStream!!.scheduledAt) * 1000) < new Date()
      ws.sendLivestreamSubscription(
        liveStream!!.id,
        email,
        timezone,
        !pastScheduledTime, // only subscribe current live stream if not past scheduled time
        similarEvents || pastScheduledTime, // subscribe for similar events if checkbox selected or past scheduled time
        false, // not used
      )
      dispatch(setUserEmail({ userEmail: email }))
      sendToWidget({ type: 'update-user-email', value: email })
      dispatch(setLiveStreamSubscribed(true))

      setEmail('')
      setTimeout(() => {
        dispatch(setGridAreaContent('Grid'))
      }, 3000)
    } catch (err) {
      log("error", err)
    }
  }

  return (
    <GridAreaContentLayout>
      <Countdown />
      { !isSubscribed && (
        <>
          <GridAreaContentLayoutTextField label={translations['SubscriptionFormInputEmailLabelNextEvents']} value={email} setValue={setEmail}/>
          <GridAreaContentLayoutCheckbox id={"futureEvents"} checked={similarEvents} setChecked={setSimilarEvents} label={translations['SubscriptionFormCheckboxSimilarEventsLabel']}/>
          <GridAreaContentLayoutButton onClick={submit} disabled={!isEmailValid} label={translations['SubscriptionFormButtonSubscribeLabel']} icon={<IoNotificationsOutline />}/>
        </>
      )}
    </GridAreaContentLayout>
  )
}

export const ReminderForm = memo(ReminderForm2Component)